import { MouseEvent, ComponentProps } from 'react';
import noop from 'lodash/noop';
import styled from 'styled-components';
import { Flex } from '../layout/Flex';

interface BackdropProps extends ComponentProps<typeof Flex> {
    onClose?: VoidFunction;
}

export const Backdrop = styled(Flex).attrs<BackdropProps>((props) => {
    const onClick = props.onClick ?? noop;

    return {
        as: 'div',
        position: 'fixed',
        onClick: (event: MouseEvent<HTMLDivElement>) => {
            onClick(event);

            if (event.target === event.currentTarget) {
                props.onClose?.();
            }
        },
    };
})<BackdropProps>`
    inset: 0;
    background-color: var(--overlay);
    backdrop-filter: blur(5px);
    -webkit-tap-highlight-color: transparent;
    color: rgb(255, 255, 255);
    z-index: 1201;
`;

Backdrop.defaultProps = {
    alignItems: 'center',
    justifyContent: 'center',
};
